import { AttaHttpClientFactory } from './http/AttaHttpClientFactory'
import { IApiResponse, ICommissionCampaignResponse, ICommissionRequest } from '@/interfaces'

const http = AttaHttpClientFactory.create(import.meta.env.VUE_APP_API_ATTA_SERVICES)

export class CommissionCampaignService {
	/**
	 * Get commission campaign
	 * @returns ICommissionCampaignResponse
	 */
	public static async getCommissionCampaigns(closingId: string) {
		const response = await http.get<IApiResponse<ICommissionCampaignResponse[]>>(`/commission-campaigns/closingId/${closingId}`)
		return response.data
	}

	/**
	 * Delete commission campaign
	 * @returns
	 */
	public static async deleteCommissionCampaign(campaignId: string) {
		const response = await http.delete<IApiResponse<ICommissionCampaignResponse>>(`/commission-campaigns/${campaignId}`)
		return response.data
	}

	/**
	 * Bind advisor to commission campaign
	 * @returns
	 */
	public static async bindAdvisorCommissionCampaign(campaignId: string, advisorId: number) {
		const response = await http.patch<IApiResponse<ICommissionCampaignResponse>>(`/commission-campaigns/${campaignId}/assigns/${advisorId}`)
		return response.data
	}

	/**
	 * Delete bind between advisor and commission campaign
	 * @returns
	 */
	public static async deleteBindAdvisorCommissionCampaign(campaignId: string, advisorId: number) {
		const response = await http.delete<IApiResponse<ICommissionCampaignResponse>>(
			`/commission-campaigns/${campaignId}/assigns/${advisorId}`
		)
		return response.data
	}

	/**
	 * Create commission campaign
	 * @returns ICommissionCampaignResponse
	 */
	public static async createCommissionCampaign(commissionRequest: ICommissionRequest) {
		const response = await http.post<IApiResponse<ICommissionCampaignResponse>>(`/commission-campaigns`, commissionRequest)
		return response.data
	}

	/**
	 * Finish commission
	 * @returns boolean
	 */
	public static async finishCommission() {
		const response = await http.patch<IApiResponse<boolean>>(`/commission/approve`)
		return response.data
	}
}
